module.exports = __webpack_public_path__ + "static/media/sea-hero-desktop.48aecbf9.jpg";